export default __webpack_public_path__ + "static/media/colors-1440w.175d88f2.png";